import {
  createGetEnvVar,
  getBaseUrl,
  getDashboardBaseUrl,
} from '@hopin-team/dashboard-constants';

export const formatDate = ({
  locale,
  date,
  style,
}: {
  locale: string;
  date: string;
  style?: 'long' | 'medium' | 'short';
}) => {
  try {
    const dateObj = new Date(date);
    const dateTimeFormat = new Intl.DateTimeFormat(locale, {
      dateStyle: style || 'long',
      timeStyle: 'short',
      hour12: true,
    });
    return dateTimeFormat.format(dateObj);
  } catch (err) {
    return '';
  }
};

export const buildTitleFromDate = ({
  locale,
  title,
  startedAt,
  style,
}: {
  locale: string;
  title?: string;
  startedAt: string;
  style?: 'long' | 'medium' | 'short';
}): string => {
  if (title) return title;
  return formatDate({
    locale,
    date: startedAt,
    style,
  });
};

export const formatDuration = (duration: number) => {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = Math.floor(duration % 60);

  const hourText = hours < 10 ? `0${hours}` : hours;
  const minutesText = minutes < 10 ? `0${minutes}` : minutes;
  const secondsText = seconds < 10 ? `0${seconds}` : seconds;

  return `${hourText}:${minutesText}:${secondsText}`;
};

export const formatDurationForTranscriptDownload = (duration: number) => {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const secondsValue = (duration % 60).toFixed(3); // preserve milliseconds to 3 dp

  const hourText = hours < 10 ? `0${hours}` : hours;
  const minutesText = minutes < 10 ? `0${minutes}` : minutes;
  const secondsText =
    Number(secondsValue) < 10 ? `0${secondsValue}` : `${secondsValue}`;

  return `${hourText}:${minutesText}:${secondsText}`;
};

export const isValidBackUrl = (url: string | null): boolean => {
  if (!url) return false;

  const baseUrl = getBaseUrl();
  const dashboardBaseUrl = getDashboardBaseUrl();
  return url.startsWith(baseUrl) || url.startsWith(dashboardBaseUrl);
};

export const getDefaultThumbnailUrl = createGetEnvVar({
  local:
    'https://usercontent.staging.events.ringcentral.com/default_images/event-default-picture-1500x600.jpg',
  staging:
    'https://usercontent.staging.events.ringcentral.com/default_images/event-default-picture-1500x600.jpg',
  review:
    'https://usercontent.staging.events.ringcentral.com/default_images/event-default-picture-1500x600.jpg',
  production:
    'https://usercontent.events.ringcentral.com/default_images/event-default-picture-1500x600.jpg',
});
